import { render, staticRenderFns } from "./EmailConfirmation.vue?vue&type=template&id=00c508ec&scoped=true&"
import script from "./EmailConfirmation.vue?vue&type=script&lang=js&"
export * from "./EmailConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./EmailConfirmation.vue?vue&type=style&index=0&id=00c508ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c508ec",
  null
  
)

export default component.exports